var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "z-breadcrumbs" }, [
    _vm.detail
      ? _c(
          "a",
          {
            staticClass: "z-button z-button--kind-text",
            attrs: { href: _vm.backLink },
          },
          [
            _c(
              "div",
              { staticClass: "z-button__icon z-button__icon--align-left" },
              [_c("z-icon", { attrs: { name: "arrow", dir: "top" } })],
              1
            ),
            _vm._v("\n        " + _vm._s(_vm.backText) + "\n    "),
          ]
        )
      : _c(
          "ul",
          { staticClass: "z-breadcrumbs__list" },
          _vm._l(_vm.data, function (item, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "z-breadcrumbs__item",
                class: { "is-current": _vm.isCurrent(item.url) },
              },
              [
                !_vm.isCurrent(item.url)
                  ? [
                      _c(
                        "a",
                        {
                          staticClass: "z-breadcrumbs__link",
                          attrs: { href: item.url, title: item.name },
                        },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(item.name) },
                          }),
                        ]
                      ),
                    ]
                  : [
                      _c("span", { staticClass: "z-breadcrumbs__link" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(item.name) },
                        }),
                      ]),
                    ],
              ],
              2
            )
          }),
          0
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }